// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"58fc55c3","405":"83f2fe0b","488":"7fc15687","682":"c9a998fb","746":"83f2fe0b"}[chunkId] + ".chunk.css";
};